module.exports = __webpack_public_path__ + "img/poocoin.bb0bfa9a.png";